<template>
  <h3 class="mb-1">
    {{ i18n.t('org.petitions.settings.petition_page.recent_signers') }}
  </h3>
  <recent-actions :recent-actions="recentActions"
                  :get-action-text="getRecentActionText"
                  background-color="#f6f6f6" />
</template>

<script>
import RecentActions from '../../campaign-action-shared/recent-actions'

export default {
  components: { RecentActions },

  props: {
    recentActions: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      getRecentActionText: (recentAction) => {
        const { name } = recentAction
        return name
      }
    }
  }
}
</script>
